import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "m-t-20"
}

import {ref, watch} from "vue";
import {useApp} from "@hview/hview-vue3/packages/hooks";
import {getTeamAddFormInfoApi, teamAddFormApproveApi} from "@/api/kh";
import {Notice, useTimeFormat} from "@hview/hview-vue3/packages";

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: "AuditPatientDialog",
  
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["on-load"],
  setup(__props, { expose: __expose, emit: __emit }) {

const {timeFormat} = useTimeFormat();
const {visible, loading} = useApp();
const model = ref({
  id: "",
  userId: "",
  status: "",
  reason: ""
});

/**
 * 详情
 */
const info = ref({});

const formRef = ref();
const reasonRef = ref();

const modelType: string = ref("");

const emits = __emit;

const rules = ref({
  status: [{ required: true, message: "请选择状态", trigger: "change" }]
});

/**
 * @description 监听审核状态变化
 */
watch(() => model.value.status, (value: string) => {
  if (value !== "rejected") {
    reasonRef.value.clearValidate();
  }
});

watch(visible, (value: boolean) => {
  if (!value) {
    if (formRef.value) {
      formRef.value.resetFields();
    }
  }
});


const load = () => {
  loading.value = true;
  getTeamAddFormInfoApi({id: model.value.id, userId: model.value.userId}).then((res: any) => {
    info.value = res.data;
  }).finally(() => {
    loading.value = false;
  });
}

/**
 * @description 打开弹窗
 */
const open = (id: string, userId: string, type: string) => {
  model.value.id = id;
  model.value.userId = userId;
  visible.value = true;
  modelType.value = type;
  load();
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      teamAddFormApproveApi({
        id: model.value.id,
        status: model.value.status,
        reason: model.value.reason
      }).then(() => {
        Notice.success("提交成功");
        emits("on-load");
        visible.value = false;
      }).finally(() => {
        loading.value = false;
      });
    }
  });
}

__expose({
  open
});

return (_ctx: any,_cache: any) => {
  const _component_h_text = _resolveComponent("h-text")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_h_dict = _resolveComponent("h-dict")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    title: modelType.value == 'audit' ? '审核' : '审核详情',
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "750"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[10] || (_cache[10] = ($event: any) => (visible.value = false))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("关闭")
        ])),
        _: 1
      }),
      (info.value.status == 'hidden')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "large",
            loading: _unref(loading),
            onClick: submit
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("提交")
            ])),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_descriptions, {
          column: 2,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              width: "150",
              label: "申请人姓名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.realname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((info.value.realname) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "昵称" }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.nickname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((info.value.nickname) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "项目名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.project_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((info.value.project_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "小组名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.team_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((info.value.team_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              span: 2,
              label: "项目描述"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.project_desc,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((info.value.project_desc) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "医生姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.doctor_realname,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((info.value.doctor_realname) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "医生昵称" }, {
              default: _withCtx(() => [
                _createVNode(_component_h_text, {
                  modelValue: info.value.doctor_nickname,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((info.value.doctor_nickname) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "提交时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(timeFormat)(info.value.createtime, "yyyy-mm-dd hh:MM:ss")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "审核时间" }, {
              default: _withCtx(() => [
                (info.value.createtime == info.value.updatetime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, "--"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(timeFormat)(info.value.updatetime, "yyyy-mm-dd hh:MM:ss")), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "审核状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_h_dict, {
                  dictKey: "audit_type",
                  mode: "text",
                  modelValue: info.value.status,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((info.value.status) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (info.value.reason)
              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: 0,
                  span: 2,
                  label: "审核意见"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_h_text, {
                      modelValue: info.value.reason,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((info.value.reason) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (info.value.status == 'hidden')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_form, {
                ref_key: "formRef",
                ref: formRef,
                onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
                "label-width": "auto",
                model: model.value,
                rules: rules.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "审核状态",
                    prop: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: model.value.status,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((model.value.status) = $event)),
                        placeholder: "请选择项目"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_h_dict, { dictKey: "audit_type_edit" })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    ref_key: "reasonRef",
                    ref: reasonRef,
                    onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
                    label: "审核意见",
                    prop: "reason",
                    rules: {
            required: model.value.status == 'rejected' ? true : false,
            message: '请输入审核意见',
            trigger: ['blur', 'change'],
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 3
                      })
                    ]),
                    _: 1
                  }, 8, ["onVnodeBeforeMount", "rules"])
                ]),
                _: 1
              }, 8, ["onVnodeBeforeMount", "model", "rules"])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _unref(loading)]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})